import * as React from 'react';
import { BaSeSmall1, BaSeTheme } from '@base/react';
import { FlexedJC } from '../fluxo/relatorio-fluxo-consolidado-styled';
import { WrapperGrid } from '../relatorios-card-styled';
import { ShowMoney } from '../../../pages/new-relatorios/relatorios-mei';

export const RelatorioDasn = ({ dados }) => {
  const { cinzaSebrae20 } = BaSeTheme.colors.institucionais;
  return (
    <>
      {dados && (
        <>
          {dados?.listaBlocosReceitas?.length &&
            dados?.listaBlocosReceitas?.map((item, index) => (
              <React.Fragment key={index}>
                <FlexedJC>
                  <WrapperGrid>
                    <BaSeSmall1 isBold color={cinzaSebrae20}>
                      {item?.tipoReceita ?? ''}
                    </BaSeSmall1>
                    <BaSeSmall1 color={cinzaSebrae20}>
                      {item?.descricao ?? ''}
                    </BaSeSmall1>
                  </WrapperGrid>
                  <ShowMoney value={item?.total} />
                </FlexedJC>
              </React.Fragment>
            ))}
          <FlexedJC last>
            <BaSeSmall1 last isBold color={cinzaSebrae20}>
              Receita Total
            </BaSeSmall1>
            <ShowMoney value={dados?.receitaTotal} />
          </FlexedJC>
        </>
      )}
    </>
  );
};
